import { AlgoliaIndexResultPlugin } from './AlgoliaPlugin.js';
import { ProductResultTaxonomy } from '../taxonomy/Taxonomies.js';
import { getIndexNameDiscovery } from '../../util/algolia.js';

var getFlyoutSearchParametersBuilderDiscovery = function getFlyoutSearchParametersBuilderDiscovery() {
  return function () {
    var defaultSearchParameters = {
      clickAnalytics: true,
      attributesToRetrieve: ['platformUrl', 'name', 'defaultImageUrl', 'inStock'],
      attributesToHighlight: ['name'],
      ruleContexts: ['defaultRuleContext'],
      getRankingInfo: true
    };
    return defaultSearchParameters;
  };
};
var FlyoutDiscoveryProductResultsPlugin = function FlyoutDiscoveryProductResultsPlugin(locale, hitsPerPage) {
  var taxonomyId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ProductResultTaxonomy.id;
  var indexName = getIndexNameDiscovery('Vistaprint', 'prod', locale);
  return AlgoliaIndexResultPlugin(indexName, indexName, taxonomyId, getFlyoutSearchParametersBuilderDiscovery(), hitsPerPage, 'products', true, 'prod');
};

export { FlyoutDiscoveryProductResultsPlugin, getFlyoutSearchParametersBuilderDiscovery };
//# sourceMappingURL=FlyoutDiscoveryResultPlugins.js.map
